// Helpers for the `visible(ctx)` checks in sidebar.config.js

export const hasRole = (targetRole) => (ctx) => ctx.role === targetRole;
export const excludesRoles = (...excludedRoles) => (ctx) => !excludedRoles.includes(ctx.role);
export const matchesAny = (...predicates) => (ctx) => predicates.some((predicate) => predicate(ctx));
export const matchesAll = (...predicates) => (ctx) => predicates.every((predicate) => predicate(ctx));
export const negate = (predicate) => (ctx) => !predicate(ctx);

export const hasClientId = (targetClientId) => (ctx) => ctx.clientId === targetClientId;
export const hasInstituteId = (targetInstituteId) => (ctx) => ctx.instituteId === targetInstituteId;
export const isNotPersonalLoan = (ctx) => !ctx.isPersonalLoanSelected;
